var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-table-cell" }, [
    _c(
      "div",
      { staticClass: "c-table-cell__wrapper cell-employee" },
      [
        _vm.canEdit
          ? _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    content: "Удалить из расчета",
                    placement: "bottom",
                  },
                  expression:
                    "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'Удалить из расчета',\n        placement: 'bottom',\n      }",
                  modifiers: { html: true },
                },
              ],
              staticClass: "cell-employee__remove",
              attrs: { size: "iconic", icon: "close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("productionRemoveWorkerFromCalc", _vm.record)
                },
              },
            })
          : _vm._e(),
        _c(
          "router-link",
          {
            staticClass: "cell-employee__name",
            attrs: {
              target: "_blank",
              to: {
                name: "personal-employee-summary",
                params: { id: _vm.record.id },
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.record.employee.value) + " ")]
        ),
        _c(
          "div",
          { staticClass: "cell-employee__info" },
          [
            _vm.record.doc_problem.length > 0
              ? _c(
                  "router-link",
                  {
                    staticClass: "cell-employee__docs-trouble",
                    attrs: {
                      target: "_blank",
                      to: {
                        name: "personal-employee-summary",
                        params: { id: _vm.record.id },
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              content: _vm.record.doc_problem,
                              placement: "top",
                            },
                            expression:
                              "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: record.doc_problem,\n            placement: 'top',\n          }",
                            modifiers: { html: true },
                          },
                        ],
                        attrs: {
                          width: "10",
                          height: "13",
                          viewBox: "0 0 10 13",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125",
                            stroke: "#FF238D",
                            "stroke-width": "2",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            false &&
            _vm.record.codeGroup === "driver" &&
            (true || _vm.record.dismissed)
              ? _c(
                  "div",
                  {
                    staticClass: "cell-employee__fired",
                    attrs: {
                      to: {
                        name: "personal-employee-summary",
                        params: { id: _vm.record.id },
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              content: `На дату расчета ${_vm.calculationDate}<br>статус водителя <b>${_vm.record.working_status}</b>`,
                              placement: "top",
                            },
                            expression:
                              "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: `На дату расчета ${calculationDate}<br>статус водителя <b>${record.working_status}</b>`,\n            placement: 'top',\n          }",
                            modifiers: { html: true },
                          },
                        ],
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7V9ZM3.49264 8V7V8ZM1 10.6478H0H1ZM0 11C0 11.5523 0.447715 12 1 12C1.55228 12 2 11.5523 2 11H0ZM11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289L11.7071 8.70711ZM7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L7.29289 10.2929ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.70711 7.29289ZM10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L10.2929 11.7071ZM5 7H3.49264V9H5V7ZM3.49264 7C2.54619 7 1.65165 7.39993 1.00196 8.09006L2.45819 9.46097C2.74342 9.15799 3.11692 9 3.49264 9V7ZM1.00196 8.09006C0.354196 8.77815 0 9.69916 0 10.6478H2C2 10.1919 2.17104 9.766 2.45819 9.46097L1.00196 8.09006ZM0 10.6478V11H2V10.6478H0ZM6.99411 2.98584C6.99411 3.52639 6.55296 3.97168 6 3.97168V5.97168C7.64968 5.97168 8.99411 4.63879 8.99411 2.98584H6.99411ZM6 3.97168C5.44704 3.97168 5.00589 3.52639 5.00589 2.98584H3.00589C3.00589 4.63879 4.35032 5.97168 6 5.97168V3.97168ZM5.00589 2.98584C5.00589 2.44529 5.44704 2 6 2V0C4.35032 0 3.00589 1.33289 3.00589 2.98584H5.00589ZM6 2C6.55296 2 6.99411 2.44529 6.99411 2.98584H8.99411C8.99411 1.33289 7.64968 0 6 0V2ZM10.2929 7.29289L8.79289 8.79289L10.2071 10.2071L11.7071 8.70711L10.2929 7.29289ZM8.79289 8.79289L7.29289 10.2929L8.70711 11.7071L10.2071 10.2071L8.79289 8.79289ZM7.29289 8.70711L8.79289 10.2071L10.2071 8.79289L8.70711 7.29289L7.29289 8.70711ZM8.79289 10.2071L10.2929 11.7071L11.7071 10.2929L10.2071 8.79289L8.79289 10.2071Z",
                            fill: "#FF238D",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.record.recommened_category !== 0
              ? _c(
                  "div",
                  {
                    staticClass: "cell-employee__rank-status",
                    class: `cell-employee__rank-status_${
                      _vm.record.recommened_category === 1 ? "up" : "down"
                    }`,
                  },
                  [
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              content: _vm.hiringRecommendation,
                              placement: "top",
                            },
                            expression:
                              "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: hiringRecommendation,\n            placement: 'top',\n          }",
                            modifiers: { html: true },
                          },
                        ],
                        attrs: {
                          width: "10",
                          height: "12",
                          viewBox: "0 0 10 12",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M5 1V11M5 11L9 7M5 11L1 7",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }